export const enMenuAnalytics = {
  'ma.tab': 'Analytics & BOM',
  'ma.title': 'Menu analytics & BOM',
  'ma.description':
    'Compare menu costs and contribution, inspect each bill of materials, and plan ingredient requirements using warehouse stock.',
  'ma.consumption': 'View actual ingredient consumption',
  'ma.noCatalog': 'Menu analytics requires permission to view the menu catalog.',
  'ma.noStock':
    'Warehouse quantities require inventory access and an inventory-enabled plan. Recipe costs are still shown.',
  'ma.coverage': 'Recipe coverage for active menu items',
  'ma.activeItems': 'Active menu items',
  'ma.costed': 'Fully costed recipes',
  'ma.attention': 'Missing or incomplete recipes',
  'ma.highCost': 'Food cost above 40%',
  'ma.economics': 'Menu economics',
  'ma.economicsHint':
    'Current weighted-average ingredient costs. Contribution = menu price minus recipe cost, before modifiers, discounts, labor, overhead and tax. This is not historical profit.',
  'ma.menuState': 'Menu status',
  'ma.all': 'All statuses',
  'ma.price': 'Menu price',
  'ma.cost': 'Cost / portion',
  'ma.margin': 'Contribution / portion',
  'ma.recipeState': 'Recipe status',
  'ma.status.ready': 'Costed',
  'ma.status.missing': 'No recipe',
  'ma.status.inactive': 'Inactive recipe',
  'ma.status.uncosted': 'Missing cost',
  'ma.status.high': 'Food cost > 40%',
  'ma.open': 'View BOM & plan portions',
  'ma.search': 'Search menu, category or recipe status',
  'ma.empty': 'Add menu items to start comparing costs and ingredient requirements.',
  'ma.bomFor': 'Bill of materials: {name}',
  'ma.bomHint':
    'Base recipe per portion. Plan one menu item at a time; modifier ingredients are not included.',
  'ma.view': 'Back to analysis',
  'ma.edit': 'Edit recipe',
  'ma.selectHint':
    'Choose “View BOM & plan portions” from a menu item’s actions to inspect its ingredients and warehouse stock.',
  'ma.modifiers': 'Modifier recipe costs',
  'ma.modifiersHint':
    'Optional or required selections change the final price and ingredients. These costs are separate from the base recipe and portion plan.',
  'ma.option': 'Modifier option',
  'ma.priceDelta': 'Price adjustment',
  'ma.inactiveHint':
    'This recipe is inactive. Activate it in the recipe editor before planning ingredient requirements.',
  'ma.missingHint':
    'No bill of materials yet. Add a recipe with inventory ingredients to calculate costs and portion requirements.',
  'ma.portions': 'Planned portions',
  'ma.portionsError': 'Enter a whole number from 1 to 10,000.',
  'ma.location': 'Stock location',
  'ma.allLocations': 'All active locations',
  'ma.stockHint':
    'On-hand estimate excludes quarantine and inactive locations or ingredients. It may include held or expired lots. Shared demand, transfers and stock reservations are not evaluated; verify usable stock before preparation.',
  'ma.batchCost': 'Planned ingredient cost',
  'ma.batchMargin': 'Planned contribution',
  'ma.capacity': 'Estimated portions on hand',
  'ma.ingredient': 'Ingredient / SKU',
  'ma.perPortion': 'Per portion',
  'ma.required': 'Required',
  'ma.onHand': 'On hand',
  'ma.shortage': 'Shortage',
  'ma.costShare': 'Recipe cost share',
  'ma.unknownHint':
    'A dash means the value is unavailable, incomplete or outside the supported numeric range. Missing costs are never treated as zero. Planning does not reserve or deduct stock.',
  'ma.sales': 'Best-selling menu items',
  'ma.salesHint':
    'Settled-bill sales, {from} to {to} ({zone}). The sales report’s top items use names recorded at sale time; current recipe costs are not applied to historical sales.',
  'ma.salesShare': 'Share of gross sales',
  'md.open': 'View item details',
  'md.back': 'Back to menu',
  'md.notFound': 'This menu item was not found in this branch.',
  'md.analytics': 'Analytics',
  'md.bom': 'Build of Material',
  'md.profitability': 'Profitability',
  'md.tabs': 'Menu item detail tabs',
  'md.days': '{days} days',
  'md.rangeError': 'Choose valid dates, in order, up to today and no more than 366 days apart.',
  'md.noReports': 'Your role cannot view sales reports for this branch.',
  'md.sold': 'Portions sold',
  'md.salesContribution': 'Share of branch sales',
  'md.orders': 'Orders containing this item',
  'md.heatmap': 'Daily sales contributions',
  'md.heatmapHint':
    'Each square is one business day. Darker squares mean more portions sold. Select a day or use the arrow keys to inspect it.',
  'md.dayLabel': '{quantity} portions on {date}',
  'md.less': 'Less',
  'md.more': 'More',
  'md.promoTitle': 'Demand during promotions',
  'md.promoHint':
    'Observed demand on days within currently active, item-linked promotion schedules. Includes zero-sale days and partial days. Compared with other days in this range, not a causal uplift estimate. Past schedule edits and disabled promotions are not reconstructed; overlapping promotions share sales.',
  'md.noPromos':
    'No currently active promotion schedule is linked to this item in the selected period.',
  'md.promoAverage': 'Portions / promotion day',
  'md.normalAverage': 'Portions / other day',
  'md.demandChange': 'Observed demand difference',
  'md.promotion': 'Promotion',
  'md.window': 'Observed window',
  'md.observedDays': 'Days',
  'md.perDay': 'Portions / day',
  'md.modifierTitle': 'Spiciness & add-on preferences',
  'md.modifierHint':
    'Selections recorded at sale time, weighted by portions. Each modifier group is shown separately. Multiple selections can make percentages add up to more than 100%. Unselected options are not counted.',
  'md.noModifiers':
    'No modifier selections were recorded for settled sales of this item in this period.',
  'md.selectionShare': 'Share of portions',
  'md.addonSales': 'Additional sales',
  'md.salesScope':
    'Settled bills only, by business date in {zone}. Includes modifier prices, before tax and service charge. Identified by menu item ID, including sales made under an earlier name.',
  'md.noSales': 'No settled sales in this period.',
  'md.currentProfit': 'Current recipe economics',
  'md.marginPercent': 'Contribution margin',
  'md.costMissing':
    'Complete and activate the recipe, and record ingredient costs to calculate profitability.',
  'md.recordedProfit': 'Recorded sales contribution',
  'md.recordedHint':
    'Historical sales less fully posted ingredient consumption for the same order lines. Includes configured modifier recipes. Excludes labor, overhead, platform fees and unconfigured ingredient recipes. This is ingredient contribution, not net profit.',
  'md.coverage': 'Portions with complete costing',
  'md.recordedCost': 'Recorded ingredient cost',
  'md.recordedContribution': 'Total ingredient contribution',
  'md.incompleteCost':
    'Some sold portions have missing, pending or incomplete consumption. Total contribution stays unknown; the covered subset is shown below.',
  'md.coveredSales': 'Sales with complete consumption',
  'md.coveredContribution': 'Contribution of costed sales only',
  'md.currentBom': 'Current bill of materials',
  'md.version': 'Version {version}',
  'md.history': 'BOM version history',
  'md.historyHint':
    'Saving a recipe creates an immutable version of its ingredients, quantities, notes and active status. Restoring an older version saves it as a new version; existing history is preserved.',
  'md.noHistory':
    'This recipe predates version tracking. Its current contents will be preserved as a baseline when it is next edited; earlier versions cannot be reconstructed.',
  'md.chooseVersion': 'Saved version',
  'md.restored': 'Previous BOM saved as a new version.',
  'md.restore': 'Restore as new version',
  'md.newest': 'Newest versions',
  'md.older': 'Older versions',
  'md.baseline':
    'Baseline captured before the first tracked edit. Costs were observed at capture time, not at the original version creation date.',
  'md.snapshotHint':
    'Saved ingredient costs are a snapshot at the time of this version. Current warehouse costs may differ.',
  'md.savedCost': 'Cost when captured',
  'md.portions': '{quantity} portions',
} as const;
